__webpack_require__.p = "https://pos-dev.joymenus.com/";